import PostRuleDataModel from './PostSecurityProfileRule.DataModel';

export default class PostSecurityProfileDataModel {
    name: string;
    description: string;
    rules: PostRuleDataModel[];
}
